import { NoOp } from '@webapp/store/ui/action-creators';
import { Actions } from './../../actions';
import { ChangeTheme } from './../action-creators';
import { CHANGE_THEME } from './../actions';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ofType } from 'redux-observable';

export const saveThemeEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, ChangeTheme>(CHANGE_THEME),
    map((action) => {
      localStorage.setItem('trac.theme', action.theme)
      return new NoOp()
    }),
  );